import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { VhEventMediator, VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  NzContextMenuService,
  NzDropdownMenuComponent,
} from 'ng-zorro-antd/dropdown';
import { JsonDataService } from 'vhobjects-service/src/services';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FunctionService } from 'vhobjects-service/src/services';
import { MatDialog } from '@angular/material/dialog';
import { ChooseImageComponent, ManageLibraryComponent } from 'vhobjects-service';
// import { ManageLibraryComponent } from '../../../../manage-library/manage-library.component';
// import { ChooseImageComponent } from '../../../../objects/basic/image/choose-image/choose-image.component';
// import { EditNameComponent } from '../../../frame-banner/config/frame-banner-config/edit-name/edit-name.component';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';

@Component({
  selector: 'atw-frame-tabs-config',
  templateUrl: './frame-tabs-config.component.html',
  styleUrls: ['./frame-tabs-config.component.scss'],
})
export class AtwFrameTabsConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() rMessage: any = {}; // Biến dùng để nhận lựa chọn (block, frame, object) { status: 1, code: '' };
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any = 'page'; 
  @Output() changeOptionConfig = new EventEmitter<any>();
  isViewAll: boolean = false;
  isCollapsed: boolean = false;
  dataAfterChange: any = {};
  tabChoosing: any = {}; // Biến dùng để lưu tab đang được chọn
  isShowContextMenu = false;
  @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại
  effect_hover = [];
  effect_hover_data: any = {};
  customize: any = [];
  public currentViewAll: any = {};
  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
  };
  public stylesField = [
    {
      title: 'dieu_chinh_bo_goc_tab_duoc_chon',
      index: 1,
    },
    {
      title: 'dieu_chinh_bo_goc_tab_chua_chon',
      index: 2,
    },
    {
      title: 'cau_hinh_chi_tiet_nut_prev',
      index: 3,
    },
    {
      title: 'cau_hinh_chi_tiet_nut_next',
      index: 4,
    },
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 5,
    },
    {
      title: 'do_bao_phu',
      index: 6,
    },
    {
      title: 'mau_gradient_duoc_chon',
      index: 7,
    },
    {
      title: 'mau_gradient_chua_chon',
      index: 8,
    },
  ];

  public optionsBackground = [
    {
      label: 'Hình nền',
      value: 'image',
    },
    {
      label: 'Màu nền',
      value: 'color',
    },
  ];

  fonts = [];
  openBorderConfig: boolean = false;
  id_subproject: string;
  isShowConfirmPopup: boolean = false;
  isConfirmLoading: boolean = false;
  isTabOverflowing: boolean = false; 
  /** Danh sách các thuộc tính (dạng object) của class */
  requiredClassFields = [
    'block-tabs',
    'block-tabs__header',
    'block-tabs__container',
    'block-tabs__container--button',
    'block-tabs__container--button-active',
    'block-tabs__container--button-inactive',
    'block-tabs__overflow-button',
    'block-tabs__button-title',
    'block-tabs__button-image',
    'block-tabs__button-text',
    'block-tabs__container--arrow',
  ];
  classUpdates = {
    "block-tabs": {
      "min-height": "100%"
    },
    "block-tabs__container--arrow": {
      "position":"absolute",
      "top": "50%",
      "right": "0",
      "display": "flex",
      "flex-direction": "row",
      "transform": "translate(0%, -50%)",
      "font-size": "20px",
      "color": "black",
      "gap": "4px"
    },
    "block-tabs__header": {
      "position": "relative",
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "flex-start",
      "align-items": "flex-start"
    },
    "block-tabs__container": {
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "flex-start",
      "align-items": "flex-start",
      "max-width": "100%",
      "max-height": "100%",
      "overflow": "auto"
    },
    "block-tabs__container--button": {
      "display": "flex",
      "justify-content": "flex-start",
      "flex-direction": "row",
      "min-width": "fit-content",
      "gap": "0px"
    },
    'block-tabs__container--button-active': {
      "flex-direction": "column"
    },
    'block-tabs__container--button-inactive': {
      "flex-direction": "column",
      "gap": "5px"
    },
    "block-tabs__button-title": {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "flex-direction": "row",
      "gap": "5px"
    },
    "block-tabs__button-sub-active": {},
    "block-tabs__button-sub-inactive": {},
  };
  configUpdates = {
    "isActive": 0,
    "isTitleAutoResize": false,
    "tab_aspect_ratio": 100,
    "tab_position": "top",
    "tab_align": "left",
    "scroll_active_tab": "center",
    "arrow":{
      "isDisplay": false,
      "position": "right",
      "distance": 4,
      "size": 20
    },
    "-webkit-scrollbar":{
      "width": "10px",
      "height": "10px",
      "display": "none",
      "background-color": "#ffffff",
      "thumb-background-color": "#888888",
      "thumb-hover-background-color": "#555555",
      "thumb-border-radius": "8px"
    },
    "animation-selected": { "id": "000000" }
  };
  staticdataUpdates = {
    "mobile_portrait_animation_type": "none",
    "mobile_landscape_animation": {
      "animation-0": {}
    },
    "mobile_landscape_animation_type": "none",
    "tablet_portrait_animation_type": "none",
    "tablet_portrait_animation": {
      "animation-0": {}
    },
    "desktop_animation_type": "none",
    "tablet_landscape_animation": {
      "animation-0": {}
    },
    "mobile_portrait_animation": {
      "animation-0": {}
    },
    "tablet_landscape_animation_type": "none",
    "desktop_animation": {
      "animation-0": {}
    }
  }


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private vhImage: VhImage,
    private vhEventMediator: VhEventMediator,
    private nzContextMenuService: NzContextMenuService,
    private jsonDataService: JsonDataService,
    public functionService: FunctionService,
    private matDialog: MatDialog,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
  }


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.requiredClassFields.forEach((field) => {
        if (!this.class.hasOwnProperty(field)) {
          this.class[field] = {}; // Khởi tạo giá trị cho class nếu chưa có (để ngăn lỗi can't read property of undefined ...)
        }
      });

      if (!this.config.box_text_box_shadow)
        this.config.box_text_box_shadow = {
          "is_box_shadow": false,
          "property_box_shadow": {
            "type": "outset",
            "h-offset": 1,
            "v-offset": 1,
            "blur": 1,
            "spread": 1,
            "color": "#ffffffff"
          }
        };
      if (!this.config.image_box_shadow)
        this.config.image_box_shadow = {
          "is_box_shadow": false,
          "property_box_shadow": {
            "type": "outset",
            "h-offset": 1,
            "v-offset": 1,
            "blur": 1,
            "spread": 1,
            "color": "#ffffffff"
          }
        };
      if (!this.config.image) this.config.image = { "object_x": 1, "object_y": 1 };
      if (!this.config["block-tabs__container--button-active_shadow"])
        this.config["block-tabs__container--button-active_shadow"] = {
          "is_box_shadow": false,
          "property_box_shadow": {
            "type": "outset",
            "h-offset": 1,
            "v-offset": 1,
            "blur": 1,
            "spread": 1,
            "color": "#ffffffff"
          }
        };
      if (!this.config["block-tabs__container--button-inactive_shadow"])
        this.config["block-tabs__container--button-inactive_shadow"] = {
          "is_box_shadow": false,
          "property_box_shadow": {
            "type": "outset",
            "h-offset": 1,
            "v-offset": 1,
            "blur": 1,
            "spread": 1,
            "color": "#ffffffff"
          }
        };
      if (!this.config["inactive-background-color"]) 
        this.config["inactive-background-color"] = {
          "gradient_arr": [
            "rgb(0, 0, 255)",
            "rgb(255, 255, 0)"
          ],
          "background": "#8c52ff",
          "gradient_check": false,
          "value_range": 1,
          "gradient_type": "linear-gradient",
          "value_parameter": 100,
          "gradient_direction": ""
        };
      if (!this.config["active-background-color"]) 
        this.config["active-background-color"] = {
          "gradient_arr": [
            "rgb(0, 0, 255)",
            "rgb(255, 255, 0)"
          ],
          "background": "#8c52ff",
          "gradient_check": false,
          "value_range": 1,
          "gradient_type": "linear-gradient",
          "value_parameter": 100,
          "gradient_direction": ""
        };

      for (const key in this.classUpdates) {
        if (!this.class.hasOwnProperty(key)) {
          this.class[key] = this.classUpdates[key];
        } else {
          for (const key2 in this.classUpdates[key]) {
            if (!this.class[key].hasOwnProperty(key2)) {
              this.class[key][key2] = this.classUpdates[key][key2];
            }
          }
        }
      }

      for (const key in this.configUpdates) {
        if (!this.config.hasOwnProperty(key)) {
          this.config[key] = this.configUpdates[key];
        } else {
          // Kiểm tra nếu cả hai bên đều là object
          if (
            typeof this.configUpdates[key] === 'object' &&
            this.configUpdates[key] !== null &&
            typeof this.config[key] === 'object' &&
            this.config[key] !== null
          ) {
            for (const key2 in this.configUpdates[key]) {
              if (!this.config[key].hasOwnProperty(key2)) {
                this.config[key][key2] = this.configUpdates[key][key2];
              }
            }
          }
        }
      }

      for (const key in this.staticdataUpdates) {
        if (!this.staticdata.hasOwnProperty(key)) {
          this.staticdata[key] = this.staticdataUpdates[key];
        }
      }

      this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
      forkJoin([
        this.http.get('assets/fonts/fonts.json'),
        this.http.get('assets/data/effects/frame-tabs.json'),
      ]).subscribe(([fonts, effects]: any) => {
        this.fonts = fonts;
        this.effect_hover = effects;
        this.effect_hover_data = this.effect_hover.find(
          (e) => e.type == this.staticdata[this.device + '_animation_type']
        );
      });

      this.tabChoosing = this.objectChoosing.objects[0];
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId)) {
      if (changes) {
        if (changes.data_config) {
          this.config = changes.config.currentValue;
        }
        if (changes.device) {
          this.device = changes.device.currentValue;
        }
        if (this.effect_hover) {
          this.effect_hover_data = this.effect_hover.find(
            (e) => e.type == this.staticdata[this.device + '_animation_type']
          );
        }
      }

      this.isTabOverflowing = this.getTabOverflowing();
    }
  }


  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {

      });
  }


  /**
   * Hàm update class và config
   */
  updateObject() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }


  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }


  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * 
   * @returns boolean true: cụm tiêu đề căn trái, false: cụm tiêu đề không khoá căn
   */
  getTabOverflowing(): boolean {
    const widthContainer = this.config['tab_aspect_ratio'] * this.class['block-tabs']['width']?.replace('px', '') / 100;
    const widthButtons = this.class['block-tabs__container--button-active']['min-width']?.replace('px', '') * this.objectChoosing.objects.length + this.class['block-tabs__container--button']['gap']?.replace('px', '') * (this.objectChoosing.objects.length - 1);
    // console.log(widthContainer <= widthButtons, widthContainer, widthButtons);
    return widthContainer <= widthButtons;
  }

  /**
   * Toggle kiểu tự động giãn đều cảu Cụm tiêu đề
   */
  handleTitleAutoResize() {
    this.class['block-tabs__container--button-inactive']['flex'] = this.config['isTitleAutoResize'] ? '1' : '0 1 auto';
    this.class['block-tabs__container--button-active']['flex'] = this.config['isTitleAutoResize'] ? '1' : '0 1 auto';
    this.class['block-tabs__container--button']['width'] = this.config['isTitleAutoResize'] ? '100%' : 'null';
    this.class['block-tabs__container--button']['height'] = this.config['isTitleAutoResize'] ? '100%' : 'null';

    if (this.config['tab_position'] == 'top' || this.config['tab_position'] == 'bottom') {
      this.class['block-tabs__container']['max-width'] = this.config['tab_aspect_ratio'] + '%';
      this.class['block-tabs__container']['max-height'] = '100%';
    }
    else {
      this.class['block-tabs__container']['max-width'] = '100%';
      this.class['block-tabs__container']['max-height'] = this.config['tab_aspect_ratio']+ '%';
    }

    this.updateObject()
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['block-tabs']['width'] = event.width + 'px';
    if (event.height) {
      this.class['block-tabs']['min-height'] = event.height + 'px';

      if (['left', 'right'].includes(this.config['tab_position'])) {
        this.class['block-tabs__header']['height'] = event.height
      } else {
        if (this.class['block-tabs__header']?.['height']) {
          delete this.class['block-tabs__header']['height'];
        }
      }
    }
    this.updateClass();
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
  }

  /**
   * Hàm này để thêm tab mới
   *
   */
  addTab() {
    let maxIndex = 0;
    this.objectChoosing.objects.forEach((item) => {
      if (item.index > maxIndex) {
        maxIndex = item.index;
      }
    });

    // Tự dộng thêm mặc định 1 banner
    this.jsonDataService.getFrame('frame_blank').subscribe((frame: any) => {
      const dataFrame = {
        id_object: this.objectChoosing._id,
        ...frame,
        name: `Tab ${maxIndex + 2}`,
        ['name_' + this.functionService.selectedLanguageCode]: 'Tab ' + (maxIndex + 2),
        ['sub_' + this.functionService.selectedLanguageCode]: 'Sub ' + (maxIndex + 2),
        is_child_tabs: true,
        index: maxIndex + 1,
        desktop_class: {
          ...frame.desktop_class,
          ['frame-blank']: {
            ...frame.desktop_class['frame-blank'],
            'background-color': this.getRandomColor(),
            width: '100%',
            height: '100%',
          },
        },
        mobile_portrait_class: {
          ...frame.mobile_portrait_class,
          ['frame-blank']: {
            ...frame.mobile_portrait_class['frame-blank'],
            'background-color': this.getRandomColor(),
            width: '100%',
            height: '100%',
          },
        },
        tablet_landscape_class: {
          ...frame.tablet_landscape_class,
          ['frame-blank']: {
            ...frame.tablet_landscape_class['frame-blank'],
            'background-color': this.getRandomColor(),
            width: '100%',
            height: '100%',
          },
        },
        tablet_portrait_class: {
          ...frame.tablet_portrait_class,
          ['frame-blank']: {
            ...frame.tablet_portrait_class['frame-blank'],
            'background-color': this.getRandomColor(),
            width: '100%',
            height: '100%',
          },
        },
        mobile_landscape_class: {
          ...frame.mobile_landscape_class,
          ['frame-blank']: {
            ...frame.mobile_landscape_class['frame-blank'],
            'background-color': this.getRandomColor(),
            width: '100%',
            height: '100%',
          },
        },
        ['desktop_position_' + this.objectChoosing._id]: {
          ...this.objectChoosing['desktop_position'],
        },
        ['mobile_portrait_position_' + this.objectChoosing._id]: {
          ...this.objectChoosing['mobile_portrait_position'],
        },
        ['tablet_landscape_position_' + this.objectChoosing._id]: {
          ...this.objectChoosing['tablet_landscape_position'],
        },
        ['tablet_portrait_position_' + this.objectChoosing._id]: {
          ...this.objectChoosing['tablet_portrait_position'],
        },
        ['mobile_landscape_position_' + this.objectChoosing._id]: {
          ...this.objectChoosing['mobile_landscape_position'],
        },
        staticdata: {
          ...frame.staticdata,
          img: '',
          text: `Tab ${maxIndex + 2}`,
          content_type: 'text',
          display: 0,
        }
      };

      this.vhQueryAutoWeb.addObject(dataFrame).then((response: any) => {
        if (response) {

        }
      }, (error) => {
        console.log('error', error)
      });
    });
  }

  getRandomColor(): string {
    const letters: string = '0123456789ABCDEF';
    let color: string = '#';
    for (let i: number = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  /**
   *
   * hàm này để cấu hình cho tab đang dược chọn
   * @param collapse
   * @param event
   */
  chooseTab(frame, event) {
    this.tabChoosing = frame;
  }

  deleteTab(frame) {
    if (frame._id == this.tabChoosing?._id) {
      this.tabChoosing = null;
    }

    this.vhQueryAutoWeb.deleteObject(frame._id).then((response: any) => {
      if (response) {
        this.objectChoosing.objects = this.objectChoosing.objects.filter(
          (item) => item._id !== frame._id
        );
      }
    });


  }

  /** Hàm thực hiện mở option lựa chọn khi chọn vào 3 chấm
   *
   * @param event
   * @param menu
   */
  onContextMenu(event: MouseEvent, menu: NzDropdownMenuComponent): void {
    this.isShowContextMenu = !this.isShowContextMenu;
    if (this.isShowContextMenu === true) {
      this.nzContextMenuService.create(event, menu);
    } else {
      this.nzContextMenuService.close();
    }
  }




  handleUploadImg(e) {
    const file = e.target?.files[0];
    if (file) {
      this.vhImage
        .getImageFromDesktop(
          file,
          'images/design/objects',
          this.tabChoosing.staticdata.img || null,
          2000000
        )
        .then(
          (rsp: any) => {
            if (rsp.vcode === 0) {

              this.tabChoosing.staticdata.img = rsp.data;
              this.updateTabChoosingStaticData();
              this.functionService.createMessage('success', 'Hình ảnh đã được tải thành công !!!');
            } else {
              this.functionService.createMessage(
                'error',
                `Tải ảnh thất bại! Lý do: ${rsp.message}`
              );
            }
          },
          (error) => {

          }
        );
    }
  }

  updateTabPosition(position, align) {
    this.config['tab_position']=position;
    this.config['tab_align']=align;
    switch (position) {
      case 'top':
        this.class['block-tabs']['flex-direction'] = 'column';
        this.class['block-tabs__container--button']['flex-direction'] = 'row';
        this.class['block-tabs__container--arrow']['flex-direction'] = 'row';
        if (this.class['block-tabs__header']?.['height']) {
          delete this.class['block-tabs__header']['height'];
        }
        // this.class['block-tabs__overflow-button']['width'] = '15px';
        // this.class['block-tabs__overflow-button']['height'] = '100%';
        // this.class['block-tabs__overflow-button']['top'] = '0';
        // this.class['block-tabs__overflow-button']['right'] = '0';
        // this.class['block-tabs__overflow-button']['bottom'] = 'unset';
        break;
      case 'bottom':
        this.class['block-tabs']['flex-direction'] = 'column-reverse';
        this.class['block-tabs__container--button']['flex-direction'] = 'row';
        this.class['block-tabs__container--arrow']['flex-direction'] = 'row';
        if (this.class['block-tabs__header']?.['height']) {
          delete this.class['block-tabs__header']['height'];
        }
        // this.class['block-tabs__overflow-button']['width'] = '15px';
        // this.class['block-tabs__overflow-button']['height'] = '100%';
        // this.class['block-tabs__overflow-button']['top'] = '0';
        // this.class['block-tabs__overflow-button']['right'] = '0';
        // this.class['block-tabs__overflow-button']['bottom'] = 'unset';

        break;
      case 'left':
        this.class['block-tabs']['flex-direction'] = 'row';
        this.class['block-tabs__container--button']['flex-direction'] = 'column';
        this.class['block-tabs__container--arrow']['flex-direction'] = 'column';
        this.class['block-tabs__header']['height'] = this.class['block-tabs']['min-height'];
        // this.class['block-tabs__overflow-button']['width'] = '100%';
        // this.class['block-tabs__overflow-button']['height'] = '15px';
        // this.class['block-tabs__overflow-button']['top'] = 'unset';
        // this.class['block-tabs__overflow-button']['right'] = 'unset';
        // this.class['block-tabs__overflow-button']['bottom'] = '0';

        break;
      case 'right':
        this.class['block-tabs']['flex-direction'] = 'row-reverse';
        this.class['block-tabs__container--button']['flex-direction'] = 'column';
        this.class['block-tabs__container--arrow']['flex-direction'] = 'column';
        this.class['block-tabs__header']['height'] = this.class['block-tabs']['min-height'];
        // this.class['block-tabs__overflow-button']['width'] = '100%';
        // this.class['block-tabs__overflow-button']['height'] = '15px';
        // this.class['block-tabs__overflow-button']['top'] = 'unset';
        // this.class['block-tabs__overflow-button']['right'] = 'unset';
        // this.class['block-tabs__overflow-button']['bottom'] = '0';
        break;
    }

    switch (align) {
      case 'left':
        this.class['block-tabs__container']['justify-content'] = 'flex-start';
        this.class['block-tabs__container']['align-items'] = 'flex-start';
        break;
      case 'center':
        this.class['block-tabs__container']['justify-content'] = 'center';
        this.class['block-tabs__container']['align-items'] = 'center';
        break;
      case 'right':
        this.class['block-tabs__container']['justify-content'] = 'flex-end';
        this.class['block-tabs__container']['align-items'] = 'flex-end';
        break;
    }
    this.handleTitleAutoResize();
    this.handleGroupButtonWrap(null);
  }

  updateArrow(){
    this.class['block-tabs__container--arrow']['gap']= this.config['arrow']['distance'] +'px'
    this.class['block-tabs__container--arrow']['font-size']= this.config['arrow']['size'] +'px'
    this.updateObject()
  }

  updateArrowPosition(position:any){
    this.config['arrow']['position']= position;
    switch (position) {
      case 'top':
        this.class['block-tabs__container--arrow']['transform']= 'translate(-50%, 0%)'
        this.class['block-tabs__container--arrow']['top']= '0'
        this.class['block-tabs__container--arrow']['bottom']= 'unset'
        this.class['block-tabs__container--arrow']['left']= '50%'
        this.class['block-tabs__container--arrow']['right']= 'unset'
        break;
      case 'bottom':
        this.class['block-tabs__container--arrow']['transform']= 'translate(-50%, 0%)'
        this.class['block-tabs__container--arrow']['top']= 'unset'
        this.class['block-tabs__container--arrow']['bottom']= '0'
        this.class['block-tabs__container--arrow']['left']= '50%'
        this.class['block-tabs__container--arrow']['right']= 'unset'
        break;
      case 'left':
        this.class['block-tabs__container--arrow']['transform']= 'translate(0%, -50%)'
        this.class['block-tabs__container--arrow']['top']= '50%'
        this.class['block-tabs__container--arrow']['bottom']= 'unset'
        this.class['block-tabs__container--arrow']['left']= '0'
        this.class['block-tabs__container--arrow']['right']= 'unset'
        break;
      case 'right':
        this.class['block-tabs__container--arrow']['transform']= 'translate(0%, -50%)'
        this.class['block-tabs__container--arrow']['top']= '50%'
        this.class['block-tabs__container--arrow']['bottom']= 'unset'
        this.class['block-tabs__container--arrow']['left']= 'unset'
        this.class['block-tabs__container--arrow']['right']= '0'
        break;
    }
    this.updateObject()
  }

  /** Hàm thực hiện việc thay đổi vị trí của các collapse trong danh sách
 *
 */
  cdkDropListDropped(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.objectChoosing.objects, event.previousIndex, event.currentIndex);
    this.objectChoosing.objects.forEach((item, index) => {
      item.index = index;
      this.vhQueryAutoWeb.updateObject(item._id, { index: item.index })
    });
  }

  /** Hàm thực hiện gọi component sửa tên phần tử
 *
 * @param frame
 */
  // editNameTab(frame) {
  //   this.matDialog
  //     .open(EditNameComponent, {
  //       width: '20%',
  //       data: (frame[`name_${this.functionService.selectedLanguageCode}`] || this.functionService.multiLanguageFallback[this.objectChoosing.component]['name']),
  //     })
  //     .afterClosed()
  //     .subscribe((result) => {
  //       if (result) {
  //         frame[`name_${this.functionService.selectedLanguageCode}`] = result;
  //         const dataUpdate = {
  //           [`name_${this.functionService.selectedLanguageCode}`]: result,
  //         };
  //         this.vhQueryAutoWeb.updateObject(frame._id, dataUpdate).then((response: any) => {
  //           if (response) {
  //           }
  //         });
  //       }
  //     });
  // }

  path = '/images';
  /**
   * Hàm xử lý lấy ảnh ở thư viện
   */
  openLibrary() {
    const dialogRef = this.matDialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path ? this.path : '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        this.tabChoosing.staticdata.img = data.href;
        this.updateTabChoosingStaticData();
      }
      this.path = data.path;
    });

  }

  handleCancelConfirm() {
    this.isShowConfirmPopup = false;
  }

  /** 
   * Lấy hình ảnh từ url đẩy lên server với kích thước hình ko thay đổi
   * */
  handleOkConfirm() {
    this.isConfirmLoading = true;
    const messages = {
      0: 'Upload ảnh thành công!!!',
      1: 'Lỗi import file ảnh!!!',
      2: 'Lỗi upload file ảnh!!!',
      3: 'Không thể upload file ảnh lớn hơn 1Mb!!!',
    };
    setTimeout(() => {
      this.vhImage.getImageFromURL(this.tabChoosing.staticdata.img, "images/design/objects", this.tabChoosing.staticdata.img.includes(this.id_subproject) ? this.tabChoosing.staticdata.img : null)
        .then((rsp: any) => {
          // 
          if (messages[rsp.vcode]) {
            this.functionService.createMessage(rsp.vcode === 0 ? 'success' : 'error', messages[rsp.vcode]);
          }
          if (rsp) {
            this.tabChoosing.staticdata.img = rsp;
            this.updateTabChoosingStaticData();
            this.functionService.createMessage('success', messages[0]);
          }
        }, error => {

          if (error.message && error.message.includes('413')) {
            // Thông báo cho người dùng
            this.functionService.createMessage('error', 'file_anh_qua_lon_vui_chon_file_anh_co_dung_luong_nho_hon_1mb');
          } else {

          }
        })
        .finally(() => {
          this.isConfirmLoading = false;
          this.isShowConfirmPopup = false;
        });
    }, 1000);
  }

  openImageFree() {
    const dialogRef = this.matDialog.open(ChooseImageComponent, {
      width: '80vw',
      height: '90vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.tabChoosing.staticdata.img = result;
        this.updateTabChoosingStaticData();
        this.isShowConfirmPopup = true;
      }
    });
  }

  updateTabChoosingStaticData() {
    const updateData = {
      staticdata: {
        ...this.tabChoosing.staticdata,
        img: this.tabChoosing.staticdata.img,
        content_type: this.tabChoosing.staticdata.content_type,
        display: this.tabChoosing.staticdata.display,
      }
    };
    
    this.vhQueryAutoWeb
      .updateObject(this.tabChoosing._id, updateData)
      .then((bool: any) => {
        if (this.tabChoosing) {
          this.tabChoosing = this.objectChoosing.objects.find((item, index) => item._id === this.tabChoosing._id);
        }
      });
  }

  updateTabChoosingName(field = 'name') {
    this.vhQueryAutoWeb.updateObject(this.tabChoosing._id, { [field + '_' + this.functionService.selectedLanguageCode]: this.tabChoosing[field + '_' + this.functionService.selectedLanguageCode] })
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;

    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.stylesField[4]);
    }
  }

  /** Xử lí lưu vị trí ảnh
   * -> xử lí dữ liệu bóng -> css:  object-position: `x y`
   */
  handleSetPositionImage() {
    this.class['block-tabs__button-image']['object-position'] = `-${this.config.image.object_x}px -${this.config.image.object_y}px`;
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_class')) this.objectChoosing['fieldUpdate'].push(this.device+'_class')
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_config')) this.objectChoosing['fieldUpdate'].push(this.device+'_config')
      return;
    }
    this.updateObject();
  }

  //Hàm xử lý scale
  scale() {
    this.class['block-tabs__button-image']['transform'] = `scale(${this.class['image__boundary--img']['transfrom_scale']})`;
    this.updateClass();
  }

  /**
   * Hàm xử lý bật/tắt cho tiêu đề chính được linh hoạt theo vị trí hoặc theo thứ tự
   * @param event true: linh hoạt, false: theo thứ tự
   */
  toggleTextFlexible(event) {
    this.config['is_text_flexible'] = event;

    if (this.config.is_text_flexible) {
      this.class['block-tabs__button-title']['position'] = "relative";
      this.class['block-tabs__button-text']['position'] = "absolute";
      this.class['block-tabs__button-text']['top'] = "100%";
      this.class['block-tabs__button-text']['left'] = "50%";
      this.class['block-tabs__button-text']['transform'] = (this.class['block-tabs__button-text']['transform'] ?? '') + " translate(-50%, -50%)";
    } else {
      delete this.class['block-tabs__button-title']['position'];
      delete this.class['block-tabs__button-text']['position'];
      delete this.class['block-tabs__button-text']['top'];
      delete this.class['block-tabs__button-text']['left'];
      delete this.class['block-tabs__button-text']['transform'];
    }

    this.updateObject();
  }

  /**
   * Hàm xử lý bật/tắt cho thanh cuộn cho phần tab
   * @param event true: bật thanh cuộn, false: tắt thanh cuộn
   */
  toggleShowScrollbar(event) {
    this.config['-webkit-scrollbar']['display'] = event ? 'block' : 'none';

    if (event) {
      this.class['block-tabs__container']['overflow'] = 'auto';
    }

    this.updateObject()
  }

  /**
   * hàm cập nhật background linear-gradient
   */
  updateBackgroundRgb() {
    const bgColorConfig = this.getGradientBg + '-background-color';
    const bgImageClass = `block-tabs__container--button-${this.getGradientBg}`;

    if (this.config[bgColorConfig].gradient_check) {
      this.class[bgImageClass]['background-image'] = "linear-gradient(" + this.config[bgColorConfig]['gradient_direction'] + this.config[bgColorConfig]['gradient_arr'] + ")";
    }
    else {
      this.class[bgImageClass]['background-image'] = "none";
    }
    this.updateObject();
  }

  /**
   * Lấy ra class active hay inactive
   */
  get getGradientBg() {
    return (this.currentViewAll.index == 8 ? 'in' : '') + 'active';
  };

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    const bgColorConfig = this.getGradientBg + '-background-color';
    const bgImageClass = `block-tabs__container--button-${this.getGradientBg}`;
  
    if (isPlatformBrowser(this.platformId)) {
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config[bgColorConfig].gradient_type = direction.type;
      this.config[bgColorConfig].gradient_direction = direction.direction;
      this.class[bgImageClass]['background-image'] = this.config[bgColorConfig].gradient_type + '(' + this.config[bgColorConfig].gradient_direction + this.config[bgColorConfig].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient = this.config[this.getGradientBg + '-background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }

  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    const bgColorConfig = this.getGradientBg + '-background-color';
    if (this.config[bgColorConfig][`gradient_arr`].length > 1) {
      this.config[bgColorConfig][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  handleGroupButtonWrap(event) {
    if (this.config.hasOwnProperty('is_group_button_wrap')) {
      const isGrButtonWrap = this.config.is_group_button_wrap;
      if (['left', 'right'].includes(this.config['tab_position'])) {
        if (isGrButtonWrap) {
          if (!this.class['block-tabs__container--button'].width)
            this.class['block-tabs__container--button'].width = '160px';
          this.class['block-tabs__container--button']['flex-wrap'] = 'wrap';
          this.class['block-tabs__container--button']['flex-direction'] = 'row';
        } else {
          if (this.class['block-tabs__container--button'].width)
            delete this.class['block-tabs__container--button'].width;
          if (this.class['block-tabs__container--button']['flex-wrap'])
            delete this.class['block-tabs__container--button']['flex-wrap'];
          this.class['block-tabs__container--button']['flex-direction'] = 'column';
        }
      } else {
        if (isGrButtonWrap) {
          if (!this.class['block-tabs__container--button'].height)
            this.class['block-tabs__container--button'].height = '260px';
          this.class['block-tabs__container--button']['flex-wrap'] = 'wrap';
          this.class['block-tabs__container--button']['flex-direction'] = 'column';
        } else {
          if (this.class['block-tabs__container--button'].height)
            delete this.class['block-tabs__container--button'].height;
          if (this.class['block-tabs__container--button']['flex-wrap'])
            delete this.class['block-tabs__container--button']['flex-wrap'];
          this.class['block-tabs__container--button']['flex-direction'] = 'row';
        }
      }
    }

    this.updateObject();
  }
}
